var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomelllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 865,
    height: 440,
    viewBox: "0 0 865 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 34",
    filter: "url(#filter0_f_361_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.421 470.543C351.992 437.378 357.556 393.145 387.849 371.746C418.141 350.347 461.69 359.886 485.118 393.051C495.797 408.167 502.878 429.017 504.556 449.26C506.559 473.432 500.857 496.738 484.371 508.384C468.163 519.833 451.11 486.849 429.315 477.302C410.376 469.007 386.314 485.963 375.421 470.543Z",
    fill: "#E1178E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_361_408",
    x: 0.927246,
    y: 0.32251,
    width: 864.013,
    height: 870.446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 180,
    result: "effect1_foregroundBlur_361_408"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomelllipse);
export default __webpack_public_path__ + "static/media/bottomelllipse.b048397430fb9867e53222352daee819.svg";
export { ForwardRef as ReactComponent };